// Live Chat mock data (approved HTML:
// 13-Live-Chat-Consistency-Review-v5.html). Multiple active chats, each
// with an independent draft, status, and verified-identity state. Doug's
// world uses Sarah Mitchell (verified subscriber), Michael Thompson
// (verified lapsed) and an anonymous visitor on the Gut X bundle page.

export interface LiveChatConversation {
  id: string;
  label: string;
  previewName: string;
  identity: 'anonymous' | 'verified';
  status: 'live' | 'typing' | 'wait';
  unreadCount: number;
  waitLabel: string;
  draft: string;
  viewing: string;
  arrival: string;
  onSite: string;
  identityText: string;
  verifiedCustomerId?: string;
  thread: Array<{
    kind: 'visitor' | 'rep' | 'note' | 'event';
    author: string;
    body: string;
    time: string;
  }>;
  suggested: string;
}

export const LIVE_CHAT_CAPACITY = 'Jamie Dorsey · 3 of 4 chats';

export const LIVE_CHAT_CONVERSATIONS: LiveChatConversation[] = [
  {
    id: 'chat_visitor_1048',
    label: 'Visitor #1048',
    previewName: 'Visitor #1048',
    identity: 'anonymous',
    status: 'live',
    unreadCount: 1,
    waitLabel: 'Waiting 2 min',
    draft: '',
    viewing: 'Gut X',
    arrival: 'Bundle Builder',
    onSite: '4 min · Sample',
    identityText: 'Identity not linked',
    thread: [
      {
        kind: 'event',
        author: '',
        body: 'Visitor started a chat from the Bundle Builder.',
        time: '2:28 PM',
      },
      {
        kind: 'visitor',
        author: 'Visitor #1048',
        body: 'Hi, is Gut X safe to use with Joint Flex Plus for a reining mare?',
        time: '2:29 PM',
      },
    ],
    suggested:
      'I can help with both. If you would like me to check a previous order, what phone number did you use?',
  },
  {
    id: 'chat_sarah_mitchell',
    label: 'Sarah Mitchell',
    previewName: 'Sarah Mitchell',
    identity: 'verified',
    status: 'typing',
    unreadCount: 0,
    waitLabel: 'Typing…',
    draft: 'Pulling up Duke’s Gut X subscription now.',
    viewing: 'Subscriptions',
    arrival: 'Account page',
    onSite: '1 min · Sample',
    identityText: 'Verified · Dallas, TX',
    verifiedCustomerId: 'contact_sarah_mitchell',
    thread: [
      {
        kind: 'rep',
        author: 'Jamie Dorsey',
        body: 'Hi Sarah, good to hear from you.',
        time: '2:24 PM',
      },
      {
        kind: 'visitor',
        author: 'Sarah Mitchell',
        body: 'Can we shift Duke’s next Gut X ship date by a week?',
        time: '2:25 PM',
      },
    ],
    suggested:
      'I can push Duke’s next Gut X order to the 20th and keep the subscription cadence intact.',
  },
  {
    id: 'chat_michael_thompson',
    label: 'Michael Thompson',
    previewName: 'Michael Thompson',
    identity: 'verified',
    status: 'wait',
    unreadCount: 2,
    waitLabel: 'Waiting 4 min',
    draft: '',
    viewing: 'Osteo-MAX PDP',
    arrival: 'Google search',
    onSite: '3 min · Sample',
    identityText: 'Verified · Dallas, TX',
    verifiedCustomerId: 'contact_michael_thompson',
    thread: [
      {
        kind: 'visitor',
        author: 'Michael Thompson',
        body: 'Looking for the research page on Osteo-MAX before I reorder.',
        time: '2:20 PM',
      },
    ],
    suggested:
      'I can send the Osteo-MAX study summary and confirm whether your previous order qualifies for a reorder discount.',
  },
];
